import { render } from "./QuestionResult.vue?vue&type=template&id=23de00ea&scoped=true&ts=true"
import script from "./QuestionResult.vue?vue&type=script&lang=ts"
export * from "./QuestionResult.vue?vue&type=script&lang=ts"

import "./QuestionResult.vue?vue&type=style&index=0&id=23de00ea&lang=less&scoped=true"
import "./QuestionResult.vue?vue&type=style&index=1&id=23de00ea&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23de00ea"]])

export default __exports__